export default __webpack_public_path__ + "static/media/use5.ec6c5780.png";